<a class="primary p-0 mr-2 cursor-pointer" title="Ver imágenes" aria-label="Ver imágenes" (click)="viewRoute()">
  <i class="ft-image font-medium-1"></i><sup *ngIf="images.length > 1" class="image-count">{{ images.length }}</sup>
</a>
